<script setup lang="ts">

</script>

<template>
  <div
    class="card-container"
  >
    <slot />
  </div>
</template>

<style scoped lang="scss">
.card-container {
  @apply relative rounded-lg overflow-hidden bg-card-background/5 border border-primary/20;

  &:hover {
    &::after {
      @apply opacity-100;
    }
  }

  &::after {
    @apply bg-gradient-to-r from-primary/[8%] to-point-color/40 transition-all duration-300 ease-[ease] opacity-0 absolute top-0 left-0 w-full h-full content-[''] z-[-1];
  }

}
</style>